import { Box, HStack, IconButton, Image, Text } from "@chakra-ui/react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactComponent as ArrowRight } from "../../../assets/icons/arrow_right_up.svg";
import { comments_data } from "../../../helpers/data-jsons";
import { useState } from "react";
import styles from "../styles";

export const UsersCommentsCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    const settings = {
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        centerMode: true,
        arrows: false,
        centerPadding: "0",
        slidesToShow: 3,
        beforeChange: (_, next) => setCurrentSlide(next),
        responsive: [
            { breakpoint: 1300, settings: { slidesToShow: 3 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } }
        ]
    };

    return (
        <Box css={styles.carouselComments} overflow={'hidden'} position="relative" mt="48px"  mb="24px" maxW="xl">
            <Slider {...settings}>
                {comments_data.map((item, index) => (
                    <Box
                        key={index}
                        bg="#23262F99"
                        boxShadow="0px 4px 4px 0px #00000040"
                        p="32px"
                        mx="auto"
                        border="1px solid #6F41D240"
                        borderRadius="24px"
                        maxW={{base: '272px', md: "496px"}}
                        cursor="pointer"
                        transition="all 0.3s ease-in-out"
                        position="relative"
                        overflow="hidden"
                        opacity={currentSlide === index ? "1" : "0.5"}
                        transform={currentSlide === index ? "scale(1.2)" : "scale(0.9)"}
                        zIndex={currentSlide === index ? "10" : "1"}
                    >
                        <Box
                            backdropFilter="blur(9px)"
                            position="absolute"
                            top="0"
                            left="0"
                            right="0"
                            bottom="0"
                            zIndex="-1"
                            borderRadius="24px"
                            bg="#23262F99"
                        />
                        <Text fontSize="body.sm" textAlign="start">
                            {item.comment.length > 300 ? item.comment.slice(0, 300) + "..." : item.comment}
                        </Text>
                        <Box
                            position="absolute"
                            top="0"
                            h="full"
                            w="full"
                            right="-300px"
                            bg="radial-gradient(50% 50% at 50% 50%, rgba(94, 148, 255, 0.24) 0%, rgba(49, 94, 255, 0) 100%)"
                        />
                        <Box
                            position="absolute"
                            top="0"
                            h="full"
                            w="4px"
                            right="0"
                            bg="linear-gradient(90deg, #191B22 0%, #5834A8 50%, #191B21 100%)"
                        />
                        <HStack mt="42px" w="full" justifyContent="space-between">
                            <HStack>
                                <Box
                                bg={'rgba(8, 4, 17, 1)'}
                                w={'52px'}
                                h={'52px'}
                                borderRadius={'50%'}
                                display={'flex'}
                                justifyContent={'center'}
                                alignItems={'center'}
                                >
                                    <Image height="30px" width="30px" src={`images/${item.user_avatar}`} />
                                </Box>
                                <Box textAlign="start">
                                    <Text>{item.username}</Text>
                                    <Text fontSize="body.sm" color="neutral.600">
                                        {item.user_type}
                                    </Text>
                                </Box>
                            </HStack>
                            <IconButton
                                _hover=""
                                w="48px"
                                h="48px"
                                borderRadius="24px"
                                bg="neutral.800"
                                icon={<ArrowRight />}
                            />
                        </HStack>
                    </Box>
                ))}
            </Slider>

            <HStack mt="40px" justifyContent="center">
                {comments_data.map((_, index) => (
                    <Box
                        key={index}
                        width={currentSlide === index ? "34px" : "12px"}
                        height="12px"
                        borderRadius={currentSlide === index ? "4px" : "4px"}
                        bg={currentSlide === index ? "purple.500" : "neutral.900"}
                        border="1px solid"
                        borderColor="neutral.800"
                        transition="all 0.3s ease-in-out"
                        cursor="pointer"
                    />
                ))}
            </HStack>
        </Box>
    );
};
